<template>
  <div>
    <div>
      <div class="px-4 py-4">
        <div class="md:max-w-6xl md:mx-auto md:flex md:items-center md:justify-between">
          <div class="flex justify-between items-center">
            <a href="#" class="inline-block py-2 text-gray-800 text-2xl font-bold">Testkit</a>
          </div>

          <div class="md:block">
            <a
              href="#"
              class="inline-block py-1 md:py-4 text-gray-800 hover:text-gray-600 mr-6"
            >Login</a>
            <a
              href="#"
              class="inline-block py-1 md:py-4 text-gray-800 hover:text-gray-600 mr-6"
            >Register</a>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gray-100 min-h-screen">
      <div class="lg:mx-32 md:mx-16 p-2">
        <div class="flex-wrap flex mt-10">
          <div class="md:w-1/3 bg-white rounded overflow-hidden md:mb-auto">
            <img
              class="bg-white object-cover"
              :src="mainImg"
              alt="nice condo"
            />
              <div class="flex flex-wrap -mb-4">
                <div class="w-1/5 mb-4  h-16">
                <img
              class="bg-white object-cover cursor-pointer"
              src="https://www.nestcondos.com/2018/images/img-nest-condos.jpg"
              alt="nice condo"
              @click="changeImg('https://condoessentials.com/pics/core-condos-01.jpg')"
              h-ref="#"
            />
                </div>
                <div class="w-1/5 mb-4 bg-gray-500 h-12">
                <img
              class="bg-white cursor-pointer "
              @click="changeImg('https://www.nestcondos.com/2018/images/img-nest-condos.jpg')"
              src="https://www.nestcondos.com/2018/images/img-nest-condos.jpg"
              alt="nice condo"
            />

                </div>
                <!-- <div class="w-1/5 mb-4 bg-gray-400 h-12"></div>
                <div class="w-1/5 mb-4 bg-gray-500 h-12"></div>
                <div class="w-1/5 mb-4 bg-gray-400 h-12"></div> -->
              </div>
          </div>
          <div class="md:w-2/3 rounded overflow-hidden">
            <div class="relative ml-4 h-full">
              <div class="font-bold text-xl mb-2">Title</div>
              <div class="text-l mb-2">Sub heading</div>
              <div class="mt-2 text-gray-800">
                <i class="fas fa-check-circle" style="color:#00FA9A;"></i>
                <span class="p-1">4/5</span>
              </div>

              <div class="text-l mb-2">Price: 45.99</div>
              <!-- <div class="bg-red-500 sm:bg-green-500  lg:bg-pink-500 xl:bg-teal-500">s</div> -->

              <div
                class="text-l mb-2"
              >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.</div>
              <div
                class="text-l mb-2"
              >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis eaque, exercitationem praesentium nihil.</div>

              <button
                class="mb-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 active:bg-green-700"
              >Buy Now</button>

            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col  md:h-56 bg-white  shadow-lg overflow-hidden md:flex-row">
        <div class="md:flex items-center justify-center md:w-1/2 md:bg-gray-700">
            <div class="py-6 px-8 md:py-0">
                <h2 class="text-gray-700 text-2xl font-bold md:text-gray-100">Sign Up For News letter Updates</h2>
                <p class="mt-2 text-gray-600 md:text-gray-400">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consectetur obcaecati odio</p>
            </div>
        </div>
        <div class="flex items-center justify-center bg-gray-400 pb-6 md:py-0 md:w-1/2 border-gray-700">
            <form>
                <div class="flex flex-col overflow-hidden sm:flex-row">
                    <input class="py-3 px-4 bg-gray-200 border-gray-800 border-2 outline-none placeholder-gray-800 focus:bg-gray-100" type="text" name="email" placeholder="Enter your email">
                    <button class="py-3 px-4 bg-gray-700 text-gray-100 font-semibold uppercase hover:bg-gray-600">subscribe</button>
                </div>
            </form>
        </div>
    </div>
        <div class="bg-gray-200 text-center py-6">
      <p class="text-sm text-blue-700 font-bold mb-2">© 2020 by testkits</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      mainImg: 'https://www.nestcondos.com/2018/images/img-nest-condos.jpg',
      defaultArr: [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ],
      selected: { name: 'Montreal', selected: false },
      restOfCities: [],
      openBox: false,
    };
  },
  mixins: [clickaway],
  computed: mapState('app', ['appTitle']),
  methods: {
    populateCities(event) {
      console.log(this.$refs.input);
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    // setCity(name, event) {
    //   // `this` inside methods point to the Vue instance
    //   // `event` is the native DOM event
    //   console.log('blur1!!')
    //   event.preventDefault()
    //   this.selected = name
    //   _.remove(this.restOfCities, { name: name, selected: false })
    //   this.restOfCities = []
    //   this.openBox = false
    // },
    handleBlur() {
      this.restOfCities = this.selected;
      console.log('blur2!!');
    },
    changeImg(url) {
      this.mainImg = url;
    },
    away() {
      this.restOfCities = [];
    },
  },
  created() {
    // const self = this;
    // window.addEventListener('click', function(){
    //   // close dropdown when clicked outside
    //   if (self.openBox === true){
    //       self.restOfCities = []
    //   }
    // })
  },
};
</script>

<style lang="css">
@import '../../public/build/tailwind.css';
</style>
